const identities = [
  { name: 'Github', url: 'https://github.com/Pavel-Durov' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/paveldurov' },
  {
    name: 'Stackoverflow',
    url: 'https://stackoverflow.com/users/5321395/pavel-durov'
  },
  {
    name: 'GoodReads',
    url: 'https://www.goodreads.com/user/show/154294414-pavel-durov'
  },
  { name: 'Hashnote', url: 'https://blog.p3ld3v.dev/' },
  { name: 'Chess.com', url: 'https://www.chess.com/member/p3ld3v' }
  // { name: 'Twitter', url: 'https://twitter.com/pav3ldurov' },
  // {
  //   name: 'Strava',
  //   url: 'https://www.strava.com/athletes/78355141'
  // },
  // { name: 'Exercism', url: 'https://exercism.org/profiles/Pavel-Durov' }
  // { name: 'Medium', url: 'https://p3ld3v.medium.com/' },
];

export default identities;
